import { Scale } from './component'
import { withProps } from 'recompose'
import config from 'config'

export { Scale } from './component'
export { ColourChip } from './component'

const enhanceWithPropsFromConfiguration = withProps({
  colorGenerator: config.colorGenerator,
  ticks: config.ticks,
  tickFormatter: config.formatAsPercent
})

export default enhanceWithPropsFromConfiguration(Scale)
